const LoyaltyAppHeader = () => null;
export { LoyaltyAppHeader };
